export default __webpack_public_path__ + "static/media/Customers.ca9bf827.svg";